import React, { Fragment } from "react";
import ActionButton from "../Buttons/ActionButton";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";

type ImageModalProps = {
  url: string;
  name: string;
  onClose: Function;
  visible: boolean;
};

const ImageModal = (props: ImageModalProps) => {
  const showHideClassName = props.visible
    ? "image-modal-container-enable"
    : "image-modal-container-disable";

  return (
    <Fragment>
      <div
        className={`image-modal-container-opacity ${showHideClassName}`}
      ></div>
      <div
        className={`image-modal-container ${showHideClassName}`}
        onClick={(e) => props.onClose(e)}
      >
        <div className="image-modal-header">
          <ActionButton
            icon={<CloseIcon />}
            onClick={(e) => props.onClose(e)}
          />
        </div>
        <div className="image-modal-body">
          <img
            className="image-modal-body-picture"
            src={props.url}
            alt={props.name}
          />
        </div>
      </div>
    </Fragment>
  );
};

export default ImageModal;
